var map = {
	"./adminprofile/add": [
		1966,
		18
	],
	"./agentprofile/add": [
		1967,
		21
	],
	"./ai_assistant/add": [
		1968,
		24
	],
	"./api_key/add": [
		1969,
		27
	],
	"./canned_answer/add": [
		1970,
		32
	],
	"./chat_configuration/add": [
		1971,
		5
	],
	"./client/add": [
		1972,
		35
	],
	"./disposition/add": [
		1973,
		40
	],
	"./field/add": [
		1974,
		43
	],
	"./form/add": [
		1975,
		46
	],
	"./form_website/add": [
		1976,
		49
	],
	"./invoice_post/add": [
		1977,
		56
	],
	"./journey/add": [
		1978,
		59
	],
	"./journey_draft/add": [
		1979,
		62
	],
	"./journey_variable/add": [
		1980,
		66
	],
	"./list/add": [
		1981,
		69
	],
	"./list_file/add": [
		1982,
		72
	],
	"./mail_account/add": [
		1983,
		75
	],
	"./operational_hours/add": [
		1984,
		78
	],
	"./organization/add": [
		1985,
		81
	],
	"./pause/add": [
		1986,
		84
	],
	"./phonenumber_monthly_cost/add": [
		1987,
		87
	],
	"./phonenumber_monthly_cost_parent/add": [
		1988,
		90
	],
	"./phonenumber_purchase/add": [
		1989,
		94
	],
	"./phonenumber_setup_cost/add": [
		1990,
		97
	],
	"./phonenumber_setup_cost_parent/add": [
		1991,
		100
	],
	"./prepaid_credit/add": [
		1992,
		107
	],
	"./queue/add": [
		1993,
		110
	],
	"./signature/add": [
		1994,
		114
	],
	"./skill/add": [
		1995,
		117
	],
	"./sla_policy/add": [
		1996,
		120
	],
	"./sound/add": [
		1997,
		123
	],
	"./stats_alarm/add": [
		1998,
		126
	],
	"./stats_custom_metric/add": [
		1999,
		129
	],
	"./stats_report/add": [
		2000,
		132
	],
	"./stats_widget/add": [
		2001,
		135
	],
	"./superadmin_profile/add": [
		2002,
		138
	],
	"./tag/add": [
		2003,
		141
	],
	"./tariff/add": [
		2004,
		144
	],
	"./tariff_parent/add": [
		2005,
		147
	],
	"./team/add": [
		2006,
		150
	],
	"./text_message_source/add": [
		2007,
		12
	],
	"./time_interval/add": [
		2008,
		154
	],
	"./user/add": [
		2009,
		157
	],
	"./voice_asterisk/add": [
		2010,
		160
	],
	"./voice_asterisk_downgrade/add": [
		2011,
		163
	],
	"./voice_route/add": [
		2012,
		170
	],
	"./voice_shortcut/add": [
		2013,
		173
	],
	"./voice_trunk/add": [
		2014,
		176
	],
	"./voice_voicemail/add": [
		2015,
		179
	],
	"./wallboard/add": [
		2016,
		182
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1885;
module.exports = webpackAsyncContext;